import { format, parseISO } from 'date-fns'
import { Badge } from '@/shared/components/ui/badge'

export function LastDayBadge({ lastDayWorked, className }: { lastDayWorked?: string | null; className?: string }) {
  if (!lastDayWorked) return null
  return (
    <Badge tone="neutral" className={className}>
      Last day {format(parseISO(lastDayWorked), 'MMM d')}
    </Badge>
  )
}
